import {Component, OnInit, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {LocalizationService} from './modules/shared/service/localization.service';
import {AuthorizationService} from './modules/shared/service/authorization.service';
import {LoggerService} from './service/logger.service';
import {RequestErrorModalComponent} from '@npm.chapps.com/chapps.common.angular.library';
import { ManifestService } from './modules/shared/service/manifest.service';
import { UpdateService } from './modules/shared/service/update.service';
import { OfflineService } from './modules/shared/service/offline.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  @ViewChild(RequestErrorModalComponent) requestErrorModal: RequestErrorModalComponent;
  public areTranslationsLoading: boolean;

  constructor(
    private translate: TranslateService,
    private localizationService: LocalizationService,
    private authorizationService: AuthorizationService,
    private loggerService: LoggerService,
    private manifestService: ManifestService,
    private updateService: UpdateService,
    private offlineService: OfflineService
  ) {
    this.areTranslationsLoading = true;
  }

  ngOnInit() {
    this.offlineService.monitorConnection();
    this.updateService.checkForUpdates();
    this.manifestService.setManifest();
    this.refreshSessionIfSignedIn();
    this.translate.use(this.localizationService.getStartingLanguage()).subscribe(() => this.areTranslationsLoading = false);
    this.loggerService.error$.subscribe(() => this.requestErrorModal.show());
  }

  private refreshSessionIfSignedIn() {
    if (this.authorizationService.isUserLoggedIn()) {
      this.authorizationService.refreshSession();
    }
  }

  public isUserLoggedIn(): boolean {
    return this.authorizationService.isUserLoggedIn();
  }
}
